import React from "react";
import { Button, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { useSelector } from "../../../../../store/store";
import { IRequest } from "../models";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../AppRoutes";
import { getStatus } from "../../../human-organization/summary-employee-request/utils/get-status";
import { recallToolDocx } from "../export/template";
import * as docx from "docx";
import { saveAs } from "file-saver";

export const ApprovalList: React.FC<{ dataSource?: IRequest[] }> = ({
  dataSource,
}) => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const history = useHistory();

  const columns: ColumnsType<IRequest> = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "age",
      key: "age",
      render(value, record, index) {
        return getDDMMYYYFormat(record?.createdDateTime);
      },
    },
    {
      title: "Người tạo",
      dataIndex: "createdBy",
      key: "createdBy",
      render(value, record, index) {
        return record?.createdBy?.user?.displayName;
      },
    },
    {
      title: "Yêu cầu",
      dataIndex: "type",
      key: "type",
      render(value, record, index) {
        return <span className="flag warning">Thu hồi</span>;
      },
    },
    {
      title: "Phòng ban",
      dataIndex: "eDepartment",
      key: "eDepartment",
      render(value, record, index) {
        return record?.fields?.eDepartment;
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render(value, record, index) {
        const status = getStatus({
          currentUser: currentUserName,
          requestStatus: record.fields.eRequestStatus,
          steps: [
            {
              status: record.fields.eApprovedStatus,
              approver: record.fields.eApprovedBy,
            },
            {
              status: record.fields.eApprovedByITLeadStatus,
              approver: record.fields.eApprovedByITLead,
            }, 
            {
              status: record.fields.eApprovedByITHeadStatus,
              approver: record.fields.eApprovedByITHead,
            },
            {
              status: record.fields.eAssigneeStatus,
              approver: record.fields.eAssignee,
            },
          ],
        });

        return <ApprovalStatus status={status} />;
      },
    },
    {
      title: "",
      dataIndex: "Download",
      key: "Download",
      render(value, record, index) {
        return (
          <Button
            onClick={(e) => {
              e.stopPropagation();

              const doc6 = recallToolDocx(record);

              docx.Packer.toBlob(doc6).then((blob) => {
                saveAs(
                  blob,
                  `Đề nghị thu hồi CCDC - ${getDDMMYYYFormat(new Date())}.docx`
                );
              });

              // try {
              //   const header = [
              //     "Tên CCDC",
              //     "Mã CCDC",
              //     "ĐVT",
              //     "Số lượng",
              //     "Lí do",
              //   ];
              //   const body: any[] = [];

              //   const eContents = JSON.parse(record?.fields?.eContent);

              //   for (const content of eContents) {
              //     body.push([
              //       content[eContent.toolName],
              //       content[eContent.toolId],
              //       content[eContent.Dram],
              //       content[eContent.Quantity],
              //       content[eContent.reason],
              //     ]);
              //   }

              //   downloadExcel({
              //     fileName: "Thu hồi CCDC_" + record.id,
              //     sheet: "1",
              //     tablePayload: {
              //       header,
              //       // accept two different data structures
              //       body: body,
              //     },
              //   });
              // } catch (error) {}
            }}
          >
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowClassName="cursor-pointer"
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            history.push(
              Routes.recallToolDetailPage.path.replace(":id", record.id)
            );
          },
        };
      }}
    />
  );
};
